import { render, staticRenderFns } from "./le-upload-file.vue?vue&type=template&id=1d8806d5&scoped=true&"
import script from "./le-upload-file.vue?vue&type=script&lang=js&"
export * from "./le-upload-file.vue?vue&type=script&lang=js&"
import style0 from "./le-upload-file.vue?vue&type=style&index=0&id=1d8806d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8806d5",
  null
  
)

export default component.exports